import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '@docpath/linces-angular-components/common';
import { Observable } from 'rxjs';

import { RoutingPath } from '../../constants/routing-path';

@Injectable({
    providedIn: 'root'
})
export class NotFoundGuard implements CanActivate {

    private readonly loginService = inject(LoginService);

     
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
        return this.loginService.checkSession(state.url, `/${RoutingPath.PATH_404}`);
    }
}
